import { useState, useEffect } from 'react';
import { Button, Col, Row, Image } from 'react-bootstrap';
import truckIcon from 'assets/img/truck-icon.svg';
import AddressModal from './AddressModal';
import { reset as resetValues } from './validations';
import AddressWidget from './AddressWidget';
import { useStorage64 } from '../../Header/Content/hooks/useStorageBase64'; // 'pages/Header/Content/hooks/useStorageBase64';
import './index.scss';
import { getAddressById } from 'services/commons/index';
import { useWindowSize } from 'hooks';

const Address = ({
  // values,
  onSaveData,
  handleBack,
  handleNext,
  onlyView = false,
  className = '',
  showBottomBar = true,
  currentAddress = false,
  agentStaffToken = null,
  addressId = null,
}) => {
  const [showModal, setShowModal] = useState(false);

  const [sendDirections] = useStorage64('sendDirections', '');

  function getAddressURL({
    calle,
    numeroExterior,
    colonia,
    codigoPostal,
    ciudad,
    estado,
  }) {
    return encodeURIComponent(
      `${calle} ${numeroExterior} ${colonia} ${codigoPostal} ${ciudad} ${estado} México`
    );
  }

  const orderFound = sendDirections.address?.find(a => a.id === addressId);
  const defaultAddress =
    orderFound ? orderFound :
    sendDirections && sendDirections.address ? sendDirections.address[0] : {};

  const initialAddress = currentAddress
    ? {
        ...resetValues,
        ...currentAddress,
        url: getAddressURL(currentAddress),
        valid: true,
      }
    : {
        ...resetValues,
        ...defaultAddress,
        url: getAddressURL(defaultAddress),
        valid: true,
      };

  const [address, setAddress] = useState(initialAddress);
  const [, { isMobile }] = useWindowSize();

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const updateAddress = (newAddress) => {
    handleClose();
    setAddress(newAddress);
    onSaveData(newAddress);
  };

  const save = () => {
    onSaveData({ ...address, valid: true });
    handleNext();
  };

  useEffect(() => {
    setAddress((current) => ({
      ...current,
      valid: Boolean(address.nombre),
    }));
  }, [address.nombre]);

  useEffect(() => {
    if(!addressId || !agentStaffToken) { return; }
    getAddressById(addressId, agentStaffToken)
      .then((address) => {
        const currentAddress = address.address;
        const values = {
          ...resetValues,
          ...currentAddress,
          url: getAddressURL(currentAddress),
          valid: true,
        };
        setAddress(values);
      })
      .catch((error) => console.log(error));

  }, []);

  return (
    <section className={`Address ${className}`}>
      {!address.nombre && !onlyView && (
        <Row>
          <Col>
            <div className="Address__Add">
              <Button
                onClick={handleShow}
                className="btn-flat btn-little-border px-4"
              >
                <Image
                  className="mr-3"
                  src={truckIcon}
                  alt="Agregar dirección"
                />
                Agregar dirección
              </Button>
            </div>
          </Col>
        </Row>
      )}

      {address.nombre && (
        <AddressWidget
          address={address}
          handleShow={handleShow}
          editAddress={!onlyView}
        />
      )}

      {!onlyView && (
        <AddressModal
          values={address}
          showModal={showModal}
          onHide={handleClose}
          onSave={updateAddress}
        />
      )}

      {!onlyView && showBottomBar && (
        <div className="table_flow_buttons">
          {!isMobile && (
            <Button
            onClick={handleBack}
            variant="secondary"
            className="btn-with-shadow"
          >
            Atrás
          </Button>
          )}
          <Button onClick={save} disabled={!address.valid} type="button">
            Siguiente
          </Button>
        </div>
      )}
    </section>
  );
};

export default Address;
